import { gql } from '@apollo/client';
import { CourseData } from './course';

export const GET_COURSE_ITEMS = gql`
  query GetCourses($query: QueryCourseInput) {
    Course_getList(query: $query) {
      data {
        ${CourseData}
      }
      count
      page
      pages
      limit
    }
  }
`;

export const CREATE_COURSE = gql`
  mutation CreateCourse($payload: CreateCourseInput!) {
    Course_create(createCourseInput: $payload) {
      ${CourseData}
    }
  }
`;

export const UPDATE_COURSE = gql`
  mutation UpdateCourse($payload: UpdateCourseInput!) {
    Course_update(updateCourseInput: $payload) {
      ${CourseData}
    }
  }
`;

export const DETAIL_COURSE = gql`
  query GetCourseById($id: String!) {
    Course_getById(id: $id) {
      ${CourseData}
    }
  }
`;

export * from './course';
